import React from 'react';
import HeroSplit from '../components/sections/HeroSplit';
import FeaturesTiles from '../components/sections/FeaturesTiles';
import Scriptores from '../components/sections/Scriptores';
import FeaturesTabs from '../components/sections/FeaturesTabs';
import CloudTransformation from '../components/sections/CloudTransformation';
import Cta from '../components/sections/Cta';

class Home extends React.Component {
  render() {
    return (
      <React.Fragment>
        <HeroSplit hasBgColor invertColor />
        <FeaturesTiles />
        <Scriptores hasBgColor invertColor topDivider bottomOuterDivider />
        <FeaturesTabs topDivider bottomOuterDivider />
        <CloudTransformation hasBgColor invertColor topDivider bottomOuterDivider />
        <Cta hasBgColor invertColor split />
      </React.Fragment>
    );
  }
}

export default Home;